module.exports = __webpack_public_path__ + "static/media/img129.2d308457.jpg";